import { render, staticRenderFns } from "./DSPlusIcon.vue?vue&type=template&id=86ba0174&scoped=true&"
import script from "./DSPlusIcon.vue?vue&type=script&lang=js&"
export * from "./DSPlusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ba0174",
  null
  
)

export default component.exports